function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M15.99,17.056c4.7,0,8.532-3.828,8.532-8.53S20.69,0,15.99,0c-4.702,0-8.528,3.823-8.528,8.525 S11.288,17.056,15.99,17.056z M15.99,2.235c3.473,0,6.294,2.824,6.294,6.29c0,3.473-2.821,6.286-6.294,6.286 c-3.466,0-6.291-2.813-6.291-6.286C9.699,5.06,12.524,2.235,15.99,2.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M31.866,30.332c-1.619-5.715-6.199-10.043-11.778-11.48c-0.061-0.021-0.12-0.037-0.185-0.043 c-1.266-0.316-2.57-0.478-3.913-0.478c-7.313,0-13.839,4.897-15.854,11.932c-0.171,0.593,0.171,1.206,0.76,1.38 c0.6,0.17,1.214-0.174,1.391-0.769c1.273-4.436,4.62-7.887,8.805-9.433v9.441c0,0.611,0.5,1.117,1.11,1.117 c0.618,0,1.122-0.506,1.122-1.117V20.825c0.867-0.169,1.758-0.258,2.667-0.258c0.888,0,1.769,0.077,2.623,0.242v10.073 c0,0.611,0.502,1.117,1.116,1.117c0.621,0,1.115-0.506,1.115-1.117v-9.456c4.223,1.537,7.604,5.021,8.873,9.505 c0.137,0.496,0.584,0.813,1.069,0.813c0.099,0,0.21-0.015,0.309-0.035C31.69,31.541,32.035,30.916,31.866,30.332z"
}));

var SvgMaleIcon = function SvgMaleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maleIcon.91354e6f.svg";
export { ForwardRef as ReactComponent };